<script>
  import { onMount, tick } from 'svelte';
  import { token, ui } from '../stores';

  let floorWrapperEl, floorEl;

  $: theme = $ui.theme || $ui.defaultTheme;

  // When clusterBoundaries or token position changes, reposition the floor.
  $: if ($token.clusterBoundaries || $ui.zoomLevel || $token.x || $token.y) {
    repositionFloor();
  }

  // $: console.log('$token.clusterBoundaries', $token.clusterBoundaries);
  // $: console.log('$ui.zoomLevel', $ui.zoomLevel);

  onMount(async () => {
    repositionFloor();
    setTimeout(() => {
      // Add the transition a wee bit after mounting so the initial floor position doesn't animate.
      floorWrapperEl.style.transition = 'transform 1000ms';
    }, 10);
  });

  // Set the floor position.
  async function repositionFloor() {
    // if (!floorWrapperEl) return;
    await tick(); // Hopefully this will fix the floor position on load problem.
    // Set defaults.
    let floorWidth = 2000;
    let floorHeight = 2000;
    let zoomRatio = 1;
    let floorOffsetLeft;
    let floorOffsetTop;
    let centeredX;
    let centeredY;

    // Get the viewport height and width. (pixels)
    const viewportWidth = floorWrapperEl.parentNode.clientWidth;
    const viewportHeight = floorWrapperEl.parentNode.clientHeight;

    // Reposition floor while fully zoomed in?
    // --------------------------------------------------------------------------------------------
    if ($token.clusterBoundaries && $ui.zoomLevel == 1) {
      // Cluster coords are based on center of peer circle. Boundaries need padding just to
      // fully contain the circles -- and a bit more to add some space around edges.
      const xPadding = 2.6;
      const yPadding = 2.6;

      // Get pixel values for left, top, width, and height of cluster.
      const clusterTop = floorHeight * ($token.clusterBoundaries.top - yPadding) * 0.01;
      const clusterRight = floorWidth * ($token.clusterBoundaries.right + xPadding) * 0.01;
      const clusterBottom = floorHeight * ($token.clusterBoundaries.bottom + yPadding) * 0.01;
      const clusterLeft = floorWidth * ($token.clusterBoundaries.left - xPadding) * 0.01;
      const clusterWidth = clusterRight - clusterLeft;
      const clusterHeight = clusterBottom - clusterTop;

      // Find the zoom level ratio for each axis. Use smaller of the two to zoom.
      const clusterWidthRatio = viewportWidth / clusterWidth;
      const clusterHeightRatio = viewportHeight / clusterHeight;
      if (clusterHeightRatio < clusterWidthRatio) {
        zoomRatio = clusterHeightRatio;
        centeredX = (viewportWidth - clusterWidth * zoomRatio) / 2;
        centeredY = 0;
      } else {
        zoomRatio = clusterWidthRatio;
        centeredX = 0;
        centeredY = (viewportHeight - clusterHeight * zoomRatio) / 2;
      }

      floorOffsetLeft = 0 - clusterLeft * zoomRatio + centeredX;
      floorOffsetTop = 0 - clusterTop * zoomRatio + centeredY;
    }

    // Set floor position at default "medium" zoom level?
    // -------------------------------------------------------------------------------------------
    else if ($ui.zoomLevel == 0) {
      // Determine the "fringe" -- the potential edge of floor outside viewport.
      const leftFringe = (floorWidth - viewportWidth) / 2;
      const topFringe = (floorHeight - viewportHeight) / 2;

      // Determine the token "bias" as a number between -1 and 1 based on token position.
      const leftBias = (($token.x - 50) / 100) * 2;
      const topBias = (($token.y - 50) / 100) * 2;

      floorOffsetLeft = 0 - (leftFringe + leftFringe * leftBias);
      floorOffsetTop = 0 - (topFringe + topFringe * topBias);
    }

    // Set floor to full view (zoom out mode) ?
    else if ($ui.zoomLevel == -1) {
      // Determine the zoomRatio (probably zoom out) based on floor size to viewport size.
      const floorWidthRatio = viewportWidth / floorWidth;
      const floorHeightRatio = viewportHeight / floorHeight;
      if (floorHeightRatio < floorWidthRatio) {
        zoomRatio = floorHeightRatio;
        floorOffsetLeft = (viewportWidth - floorWidth * zoomRatio) / 2;
        floorOffsetTop = 0;
      } else {
        zoomRatio = floorWidthRatio;
        floorOffsetLeft = 0;
        floorOffsetTop = (viewportHeight - floorHeight * zoomRatio) / 2;
      }
    }
    floorWrapperEl.style.transform = `matrix(${zoomRatio}, 0, 0, ${zoomRatio}, ${floorOffsetLeft}, ${floorOffsetTop})`;
  }
</script>

<svelte:window on:resize="{repositionFloor}" />

<!-- Floor Wrapper -->
<div
  id="Floor"
  class="absolute left-0 top-o overflow-hidden"
  style="height: 2000px; width: 2000px; transform-origin: top left"
  bind:this="{floorWrapperEl}">
  <!-- Floor -->
  <div
    class="absolute left-0 top-0 flex w-full h-full justify-center items-center overflow-hidden"
    style="background: {theme.floor.background.color || `url(${theme.floor.background.image})`};"
    bind:this="{floorEl}">
    <div class="z-20" style="height:100vh; width:100vw">
      <slot />
    </div>

    <!-- Logo -->
    {#if theme.floor.logo}
      {@html theme.floor.logo}
    {/if}
  </div>
</div>
